import React from "react"
import ToSort from "./ToSort"

function ToSortFilters(props) {
	return <ToSort handleChangeSort={props.handleChangeSort} />
}
export default ToSortFilters
